import React from "react";
import "./ImageCard.scss";

const ImageCard = ({ image, title, category, count, address, description }) => {
  return (
    <div className="image-card3">
      <div className="card-details3">
        <p className="collection3">{category}</p>
        <p className="subtitle3">Collection reproduction</p>
      </div>
      <div className="image-wrapper3">
        <img src={image} alt={title} />
        <div className="overlay3">
          <h3 className="title3">{title}</h3>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;
